<template>
  <div class="min-h-screen bg-login flex flex-col px-6 py-10">
    <!-- Logo设计 -->
    <div class="text-center mb-10 mt-6">
      <div class="inline-flex items-center justify-center">
        <svg class="w-12 h-12 mr-2" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#2563EB" fill-opacity="0.1"/>
          <path d="M15.5 15C17.433 15 19 13.433 19 11.5C19 9.567 17.433 8 15.5 8C13.567 8 12 9.567 12 11.5C12 13.433 13.567 15 15.5 15Z" fill="#2563EB"/>
          <path d="M24.5 15C26.433 15 28 13.433 28 11.5C28 9.567 26.433 8 24.5 8C22.567 8 21 9.567 21 11.5C21 13.433 22.567 15 24.5 15Z" fill="#2563EB"/>
          <path d="M30 21C31.933 21 33.5 19.433 33.5 17.5C33.5 15.567 31.933 14 30 14C28.067 14 26.5 15.567 26.5 17.5C26.5 19.433 28.067 21 30 21Z" fill="#2563EB"/>
          <path d="M10 21C11.933 21 13.5 19.433 13.5 17.5C13.5 15.567 11.933 14 10 14C8.067 14 6.5 15.567 6.5 17.5C6.5 19.433 8.067 21 10 21Z" fill="#2563EB"/>
          <path d="M20 32C24.4183 32 28 28.4183 28 24C28 19.5817 24.4183 16 20 16C15.5817 16 12 19.5817 12 24C12 28.4183 15.5817 32 20 32Z" fill="#2563EB"/>
        </svg>
        <h1 class="text-3xl font-bold logo-text tracking-tight">AirPets</h1>
      </div>
      <p class="mt-3 text-gray-600">智能宠物监测平台</p>
    </div>

    <!-- 登录表单 -->
    <div class="bg-white rounded-2xl shadow-lg p-6 w-full">
      <form @submit.prevent="handleLogin" class="space-y-5">
        <!-- 手机号输入 -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2 ml-1">手机号</label>
          <div class="relative">
            <span class="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400">
              <i class="fas fa-mobile-alt"></i>
            </span>
            <input 
              v-model="ruleForm.userPhone"
              type="tel" 
              class="w-full pl-10 pr-4 py-3.5 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors text-base" 
              placeholder="请输入手机号"
              pattern="[0-9]{11}"
              required
            >
          </div>
        </div>

        <!-- 密码输入 -->
        <div>
          <div class="flex items-center justify-between mb-2">
            <label class="block text-sm font-medium text-gray-700 ml-1">密码</label>
            <a href="#" class="text-sm text-blue-600 hover:text-blue-700">忘记密码？</a>
          </div>
          <div class="relative">
            <span class="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400">
              <i class="fas fa-lock"></i>
            </span>
            <input 
              v-model="ruleForm.userPassword"
              type="password" 
              class="w-full pl-10 pr-4 py-3.5 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors text-base" 
              placeholder="请输入密码"
              required
            >
          </div>
        </div>

        <!-- 记住我 -->
        <div class="flex items-center">
          <input 
            v-model="remember"
            type="checkbox" 
            class="h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500" 
            id="remember"
          >
          <label for="remember" class="ml-2 text-base text-gray-600">记住我</label>
        </div>

        <!-- 登录按钮 -->
        <button 
          type="submit" 
          class="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-3.5 rounded-xl text-base font-medium hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors shadow-lg"
          :disabled="loading"
        >
          <i v-if="loading" class="fas fa-spinner fa-spin mr-2"></i>
          {{ loading ? '登录中...' : '登录' }}
        </button>

        <!-- 注册链接 -->
        <p class="mt-4 text-center text-base text-gray-600">
          还没有账号？
          <router-link to="/register" class="text-blue-600 hover:text-blue-700 font-medium">立即注册</router-link>
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { RPC } from '@/api/rpc'
export default {
  name: 'Login',
  data() {
    return {
      ruleForm: {
        userPhone: '',
        userPassword: ''
      },
      phone: '',
      password: '',
      remember: false,
      loading: false,
      countdown: 0,
      timer: null
    }
  },
  mounted() {
    if (localStorage.getItem('username')) {
      this.remember = true
      this.ruleForm = {
        userPhone: localStorage.getItem('username'),
        userPassword: atob(localStorage.getItem('password'))
      }
    }
  },
  methods: {
    ...mapActions(['login']),
    async handleLogin() {
      
      if (!this.ruleForm.userPhone || !this.ruleForm.userPassword) {
        this.$toast.fail('请填写完整信息')
        return
      }
      
      // 验证手机号格式
      if (!/^1[3-9]\d{9}$/.test(this.ruleForm.userPhone)) {
        this.$toast.fail('请输入正确的手机号')
        return
      }
      
      this.loading = true
      RPC.login(this.ruleForm).then(res=>{
        console.log('res',res);
        // sessionStorage.setItem('info',JSON.stringify(res.data))
        sessionStorage.setItem('deviceCode',res.data.machineId)
        this.loading = false
        this.rememberFun()
        this.login({
          token: res.data.userToken,
          user: res.data
        })
      }).catch(err=>{
        console.log('err',err);
        this.loading = false
        // this.$toast.fail(err.response.data.message)
      })
    },
    rememberFun() {
      if (this.remember) {
        localStorage.setItem('username', this.ruleForm.userPhone);
        localStorage.setItem('password', btoa(this.ruleForm.userPassword)); // 使用btoa加密密码
      }
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.bg-login {
  background: linear-gradient(135deg, #EBF4FF 0%, #F0F9FF 100%);
}
.logo-text {
  background: linear-gradient(135deg, #2563EB 0%, #1E40AF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.ml-1 {
  text-align: left;
}
</style> 